"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MenuItem_1 = require("@material-ui/core/MenuItem");
var TextField_1 = require("@material-ui/core/TextField");
var React = require("react");
var tubular_common_1 = require("tubular-common");
var dropdown = {
    marginLeft: '10%',
    marginTop: '5%',
    width: '80%',
};
var BooleanInputOperators = [
    { Value: 'true', Title: 'True' },
    { Value: 'false', Title: 'False' },
];
var ColumnDataTypeToHtmlType = {
    boolean: 'text',
    date: 'date',
    datetime: 'datetime-local',
    datetimeutc: 'datetime-local',
    numeric: 'number',
    string: 'text',
};
var getValue = function (dataType, operator, value, handleTextFieldChange) {
    switch (dataType) {
        case tubular_common_1.ColumnDataType.DATE:
            if (value) {
                return tubular_common_1.formatDate(value, 'yyyy-MM-DD');
            }
            handleTextFieldChange(tubular_common_1.formatDate(new Date().toISOString(), 'YYYY-MM-DD'));
            return '';
        case tubular_common_1.ColumnDataType.DATE_TIME:
        case tubular_common_1.ColumnDataType.DATE_TIME_UTC:
            if (value) {
                return tubular_common_1.formatDate(value, 'yyyy-MM-DD[T]HH:mm');
            }
            handleTextFieldChange(tubular_common_1.formatDate(new Date().toISOString(), 'yyyy-MM-DD[T]HH:mm'));
            return '';
        case tubular_common_1.ColumnDataType.BOOLEAN:
            return operator === tubular_common_1.CompareOperators.NONE
                ? ''
                : typeof value === 'boolean'
                    ? value === true
                        ? 'true'
                        : 'false'
                    : value;
        default:
            return operator === tubular_common_1.CompareOperators.NONE ? '' : value || '';
    }
};
exports.DialogInput = function (_a) {
    var column = _a.column, handleTextFieldChange = _a.handleTextFieldChange, isPrimary = _a.isPrimary;
    var value = getValue(column.DataType, column.Filter.Operator, isPrimary ? column.Filter.Text : column.Filter.Argument[0], handleTextFieldChange) || '';
    var disabled = isPrimary ? column.Filter.Operator === tubular_common_1.CompareOperators.NONE : false;
    var label = isPrimary
        ? column.Filter.Operator !== tubular_common_1.CompareOperators.BETWEEN
            ? 'Value'
            : 'First Value'
        : 'Second Value';
    var handleChange = function (e) { return handleTextFieldChange(e.target.value); };
    return (React.createElement(TextField_1.default, { select: column.DataType === tubular_common_1.ColumnDataType.BOOLEAN, style: dropdown, id: column.Name, disabled: disabled, value: value, label: label, type: ColumnDataTypeToHtmlType[column.DataType], onChange: handleChange }, column.DataType === tubular_common_1.ColumnDataType.BOOLEAN &&
        BooleanInputOperators.map(function (option) { return (React.createElement(MenuItem_1.default, { key: option.Value, value: option.Value }, option.Title)); })));
};
